import { TextField, useTheme } from "@mui/material";
import React from "react";
export const QuantitySelect = ({ disabled = false, onChange, value }) => {
    const theme = useTheme();
    const handleChange = (event) => {
        onChange && onChange(parseInt(event.target.value));
    };
    return (React.createElement(TextField, { disabled: disabled, onChange: handleChange, select: true, SelectProps: { native: true }, size: "small", sx: { borderRadius: theme.shape.borderRadius, width: "5rem" }, value: value, variant: "outlined" }, Array(20)
        .fill("")
        .map((_, ix) => (React.createElement("option", { key: `qty-${ix}`, value: ix + 1 }, ix + 1)))));
};
//# sourceMappingURL=quantity-select.js.map